import React from "react";
import Tooltip from "@mui/material/Tooltip";
import "./index.css";

export const HelpTooltip = ({
  text,
  ariaLabel,
  className = "",
  placement = "bottom",
  enterTouchDelay = 0,
}) => {
  if (!text) return null;

  return (
    <Tooltip
      title={text}
      describeChild
      placement={placement}
      enterTouchDelay={enterTouchDelay}
      componentsProps={{
        tooltip: {
          sx: {
            fontSize: "var(--font-size-body, 16px)",
            "&.MuiTooltip-touch": { fontSize: "var(--font-size-body, 16px)" },
            backgroundColor: "#1a1b2b",
            color: "#ffffff",
            border: "1px solid rgba(255, 255, 255, 0.15)",
            padding: "6px 12px",
            borderRadius: "6px",
            fontWeight: 500,
            lineHeight: 1.4,
            boxShadow: "0 4px 14px rgba(0, 0, 0, 0.4)",
          },
        },
      }}
    >
      <button
        type="button"
        className={`help-tooltip-trigger ${className}`.trim()}
        aria-label={ariaLabel}
      >
        ?
      </button>
    </Tooltip>
  );
};

export default HelpTooltip;
